import React, { useEffect, useState } from "react";
import { columns, LedgerPaymentReportColumn } from "./columns";
import { DataView } from "../../../components/table/table";
import { useApi } from "../../../helper/apiHook";
import { LeadReportFilter } from "./filter";
import { Button } from "reactstrap";
import { downloadIcon, filterIcon } from "../../../constant/icons";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { getFormattedDate } from "../../../utils/dateUtils";
import ModalView from "../../../components/modal";
import { invokeApi } from "../../../helper/api";
import { GET } from "../../../constant/commonConst";

export default function ClientList() {
  const [filterValues, setFilterValues] = useState<any>({});
  const [reportData, setReportData] = useState<any>({});
  const [isModal, setIsModal] = useState<any>(false);
  const [filter, setFilter] = useState<boolean>(false);
  const api = useApi("/clients/report", true, filterValues);
  useEffect(() => {
    api.mutate();
  }, []);

  const handleShowFilter = () => {
    setFilter(!filter);
  };

  const exportToExcel = async () => {
    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // Define the headers
    const headers = [
      { header: "Business Name", key: "businessName", width: 30 },
      { header: "Booking Date", key: "bookingDate", width: 25 },
      { header: "Booking No", key: "bookingNo", width: 20 },
      { header: "Total Amount", key: "totalAmount", width: 20 },
      { header: "Received Amount", key: "receivedAmount", width: 20 },
      { header: "Balance", key: "balance", width: 20 },
    ];

    // Add the header row with styles
    worksheet.columns = headers;

    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White text
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "000000" }, // Black background
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Map your API data
    const data = api.data.map((item: any) => ({
      businessName: item.businessName || "",
      bookingDate: getFormattedDate(item.bookingDate),
      bookingNo: item.bookingNo || "",
      totalAmount: item.totalAmount || 0,
      receivedAmount: item.recivedAmount || 0,
      balance: item.balance || 0,
    }));
    // Add the data rows
    data.forEach((item: any) => {
      worksheet.addRow(item);
    });
    // Generate buffer for Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    // Create a Blob and trigger the download
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `ledger_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };
  const showModal=async(data:any)=>{
      const response = await invokeApi(GET, `/clients/report-payment/${data.id}`,{});
      if(response?.data){
        const unShiftData = response?.data?.data && response?.data?.data.length > 0 ? response?.data?.data.map((element:any)=>{
          return {
            ...element,
            totalAmount:response?.data?.data.length > 1 ? "":element.totalAmount
          }
        }):[];
        if(unShiftData.length > 1){
           unShiftData.unshift({
                    businessName:response?.data?.data[0].businessName,
                    personName:"",
                    paymentDate: response?.data?.data[0].bookingDate,
                    totalAmount:response?.data?.data[0].totalAmount,
                    amount:0,
                    balance:response?.data?.data[0].balance,
                })
        }
        const responseData = response?.data && response?.data?.data?.length > 0 ? {
          ...response?.data,
          data:unShiftData
        }:[];
          setReportData(responseData)
          setIsModal(true)
      }else{
          setReportData([])
      }
  }
  const exportToExcelLedgerReport = async () => {
            // Create a new workbook and worksheet
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Receipt Report');
    
            // Define the headers based on the receiptColumns structure
            const headers = [
                { header: 'Business Name', key: 'businessName', width: 30 },
                { header: 'Person Name', key: 'personName', width: 30 },
                { header: 'Payment Date / Booking Date', key: 'paymentDate', width: 30 },
                { header: 'Total Booking Amount', key: 'totalAmount', width: 25 },
                { header: 'Received Amount', key: 'amount', width: 20 },
                { header: 'Balance', key: 'balance', width: 20 },
            ];
    
            // Add the headers to the worksheet
            worksheet.columns = headers;
    
            // Style the header row (optional)
            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '000000' }, // Black background
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
            // Assuming 'filteredRows' is the data you want to export
            const data = reportData?.data && reportData?.data.length > 0 && reportData?.data.map((item:any) => {
                return {
                    "businessName": item?.businessName,
                    "personName": item.personName ?? "-",
                    "paymentDate": getFormattedDate(item?.paymentDate ? item?.paymentDate:item.bookingDate),
                    "totalAmount": item?.totalAmount,
                    "amount": item?.amount ?? 0,
                    "balance": item?.balance,
                }
            });
    
            // Add the data rows
            data.forEach((item:any) => {
                worksheet.addRow(item);
            });
    
            // Generate the Excel buffer and trigger download
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `Ledger_Details_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
  };

  return (
    <>
      <div
        className="d-flex justify-content-end align-items-end"
        style={{ paddingRight: "1rem" }}
      >
        <div className="head-btn-box">
          <Button
            color="secondary"
            type="button"
            outline
            onClick={exportToExcel}
          >
            {downloadIcon.icon}
            Download
          </Button>
          <Button
            color="secondary"
            type="button"
            outline
            onClick={handleShowFilter}
          >
            {filterIcon.icon}
            Filter
          </Button>
        </div>
      </div>
      <div style={{ marginTop: "3rem" }}>
        <DataView
          columns={columns({
            api,
            showModal
          })}
          rows={api.data}
          updatePagination={api.updatePagination}
          currentPage={api.currentPage}
          rowCount={api.rowCount}
          limit={api.limit}
        />
        {filter && (
          <LeadReportFilter
            filterValues={filterValues}
            setFilterValues={setFilterValues}
            onCloseFilter={handleShowFilter}
          />
        )}
         <ModalView
            modalView={isModal}
            modalName={<div className='d-flex align-items-center justify-content-between'>
                <p className='m-0'>Ledger Detail Report</p>
                <Button color='success' className='mr-2' onClick={()=>{
                    exportToExcelLedgerReport();
                }}>Download Excel</Button>
            </div>}
            onModalDismiss={() => {
                setIsModal(false)
            }}
            customClass={"ledge-details-report"}
            modalsize={"xl"}
        >
                        
            <DataView
                columns={LedgerPaymentReportColumn()}
                rows={reportData.data}
                offPagination={true}
            />
        </ModalView>
      </div>
    </>
  );
}
